export const CONFIRMED = "rgb(255,255,153)";
export const DEATHS = "rgb(255, 153, 153)";
export const VACCINATED = "rgba(153, 255, 255)"
export const PARTIALLY_VACCINATED = "rgb(200,255,153)"
export const NON_VACCINATED = "rgba(120, 120, 120)"
export const CONFIRMED_BAR = "rgb(238, 238, 155)";
export const CONFIRMED_LINE = "rgb(255, 204, 0)";
export const DEATH_LINE = "rgb(255, 0, 0)";
export const DEATH_BAR = "rgb(238, 153, 153)";

export const COUNTRY = "rgb(102,102,102)";
